var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.isMobile)?_c('HeaderMobile'):_c('Header'),_c('v-main',[_c('router-view')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }